export default "__VITE_ASSET__Nhn$6s4I__"